// ===================================================================
// src/app/components/common/ChunkErrorBoundary.tsx
//
// Captura falhas de carregamento de chunks lazy (deploy novo com a aba
// antiga aberta) e mostra a página "build desatualizado" em vez de um
// ecrã branco. Qualquer outro erro é re-lançado para o Sentry.ErrorBoundary.
// ===================================================================

import { Component, type ReactNode } from 'react';
import BuildDesatualizado from '../../pages/BuildDesatualizado';

function isChunkLoadError(error: unknown): boolean {
  const msg = error instanceof Error ? `${error.name} ${error.message}` : String(error);
  return /Loading chunk|Loading CSS chunk|Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i.test(
    msg,
  );
}

interface Props { children: ReactNode }
interface State { stale: boolean }

export class ChunkErrorBoundary extends Component<Props, State> {
  state: State = { stale: false };

  static getDerivedStateFromError(error: unknown): State | null {
    return isChunkLoadError(error) ? { stale: true } : null;
  }

  componentDidCatch(error: unknown) {
    if (!isChunkLoadError(error)) throw error;
  }

  render() {
    if (this.state.stale) return <BuildDesatualizado />;
    return this.props.children;
  }
}

export default ChunkErrorBoundary;
